var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4120_10971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58489 4.16602H15.4182C15.5382 4.20811 15.647 4.27711 15.7363 4.36774C15.8255 4.45836 15.8928 4.56821 15.933 4.68887C15.9732 4.80952 15.9853 4.93778 15.9683 5.06382C15.9513 5.18986 15.9056 5.31033 15.8349 5.41602L11.6682 9.99935V15.8327L8.33489 13.3327V9.99935L4.16822 5.41602C4.09746 5.31033 4.05183 5.18986 4.03483 5.06382C4.01782 4.93778 4.02989 4.80952 4.07011 4.68887C4.11033 4.56821 4.17763 4.45836 4.26686 4.36774C4.35608 4.27711 4.46487 4.20811 4.58489 4.16602Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4120_10971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.382d00296cd64dbe97fecc759d906329.svg";
export { ForwardRef as ReactComponent };